import React, {createRef, RefObject} from "react"
import {findDOMNode} from "react-dom"

import Popover from "../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../gd-components/gd-popover/popover-position"
import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import SelectMultiGenericPopoverSearch from "./popover-search"
import SelectMultiGenericPopoverOptionsSelector from "./popover-options-selector"
import SelectMultiGenericNew from "../select-multi-generic-new"
import UILoading from "../../loading/loading"

const SEARCH_SHOW_THRESHOLD = 6 // min options to show search input

type Props = {
    parent                          : SelectMultiGenericNew

    options?                        : Option[]
    getPopoverOptions?              : {(): Promise<Option[]>}

    allValuesOptionLabel            : string
    allValuesOption                 : boolean   // is all values option available

    popoverContainerClasses?        : string
    popoverClasses?                 : string
    popoverScrollContainerClasses?  : string

    isSearchable                    : boolean

    popoverOptionComponent?         : func
}

type State = {
    searchString    : string | null
    options?        : Option[]
    optionsLoaded   : boolean
}

// const debug = "SelectMultiGenericPopoverMenu"
const debug = false

export default class SelectMultiGenericPopoverMenu extends React.Component<Props, State> {

    private refScroll           : RefObject<VScroll>                                    = createRef<VScroll>()
    private refOptionsSelector  : RefObject<SelectMultiGenericPopoverOptionsSelector>   = createRef<SelectMultiGenericPopoverOptionsSelector>()

    constructor(props: Props) {
        super(props)

        this.state = {
            searchString    : null,
            options         : props.options,
            optionsLoaded   : !props.getPopoverOptions,
        }
    }

    componentDidMount() {
        if (!this.state.optionsLoaded) {
            this.loadOptions()
        }
    }

    private async loadOptions() {
        const options = await this.props.getPopoverOptions?.()
        if (_.isEmpty(options)) {
            this.setState({
                optionsLoaded   : true
            })
        } else {
            this.setState({
                options         : options,
                optionsLoaded   : true
            })
        }
    }

    onPopoverKeyDown = (e: React.KeyboardEvent) => {
        this.refOptionsSelector.current?.onPopoverKeyDown(e)
    }

    onSearchChange = (newSearchString: string) => {
        this.setState({
            searchString: newSearchString
        })
    }

    updateScroll = (node: any) => {
        if (!this.refScroll.current) return

        const scrollNode: any = findDOMNode(this.refScroll.current.childrenContainer)

        const nodeTop = node.offsetTop
        const nodeBottom = node.offsetTop + node.offsetHeight
        const scrollTop = scrollNode.scrollTop
        const scrollBottom = scrollNode.scrollTop + scrollNode.offsetHeight

        // ensure node to be in visible area of scroll
        if (scrollBottom < nodeBottom) this.refScroll.current.setScrollTop(nodeBottom - scrollNode.offsetHeight, false, 100)
        else if (scrollTop > nodeTop) this.refScroll.current.setScrollTop(nodeTop, false, 100)
    }

    render() {
        debug && console.log(debug, 'render', this.state.options)

        const popoverPosition = new PopoverPosition({
            attachment      : "top center",
            targetAttachment: "bottom center",
        })

        return (
            <Popover
                className               = {this.props.popoverContainerClasses}
                     position           = {popoverPosition}
                     getTargetFunc      = {() => findDOMNode(this.props.parent)}
                     onKeyDown          = {this.onPopoverKeyDown}
                     onClickOutside     = {() => {
                         this.props.parent.hidePopover()
                     }}
            >

                {this.state.optionsLoaded &&
                    <>
                        <SelectMultiGenericPopoverSearch searchable     = {this.props.isSearchable && (!!this.state.options && this.state.options.length > SEARCH_SHOW_THRESHOLD)}
                                                         searchString   = {this.state.searchString}
                                                         onHidePopover  = {this.props.parent.hidePopover}
                                                         onSearchChange = {this.onSearchChange}/>

                        <div className={Classes("ui5-popover-menu", this.props.popoverClasses)}>
                            <VScroll ref                = {this.refScroll}
                                     minDragHeight      = {20}
                                     containerClass     = {this.props.popoverScrollContainerClasses}
                                     scrollVisibility   = "auto">
                                <SelectMultiGenericPopoverOptionsSelector ref                       = {this.refOptionsSelector}
                                                                          options                   = {this.state.options!}
                                                                          allValuesOptionLabel      = {this.props.allValuesOptionLabel}
                                                                          allValuesOption           = {this.props.allValuesOption}
                                                                          parent                    = {this.props.parent}
                                                                          popoverOptionComponent    = {this.props.popoverOptionComponent}
                                                                          searchString              = {this.state.searchString}
                                                                          onUpdateScroll            = {this.updateScroll}/>
                            </VScroll>
                        </div>
                    </>}

                {!this.state.optionsLoaded &&
                    <div className={Classes("ui5-popover-menu", this.props.popoverClasses)}>
                        <div className="flex-row-center-center w-200 h-100">
                            <UILoading className="inline" size="normal" message=""/>
                        </div>
                    </div>
                }
            </Popover>
        )
    }
}
